export default {
  storeNamespace: 'renting_preparation',
  storeSaveItemAction: 'saveItemProducts',
  authFeature: 'renting-preparation',
  listRouteName: "RentingPreparationList",
  sortBy: 'preparation_date',
  sortDesc: true,
  hideActionNewButton: true,
  hideActionEditButton: true,
  hideActionPdfButton: true,
  hideActionDeleteButton: true,
  useEditModal: true,
  fields: [
    // List
    {
      name: 'tabs',
      label: "",
      tabFilter: true,
      tabFilterDefaultValue: 'past'
    },
    {
      name: 'renting',
      label: "Commande",
      type: 'text',
      inList: true,
      sortable: true,
      filterIn: true,
      inCsvExport: true,
    },
    {
      name: 'preparation_date',
      label: "Date de préparation",
      type: 'text',
      inList: true,
      sortable: true,
      inCsvExport: true,
    },
    {
      name: 'preparation_date',
      label: "Date de préparation",
      type: 'date',
      extendedFilter: true,
    },
    {
      name: 'preparator',
      label: "Préprateur",
      type: 'select',
      inList: true,
      sortable: true,
      extendedFilter: true,
      inCsvExport: true,
    },
    {
      // INC-004 : entrepôt de rattachement de la préparation
      name: 'warehouse',
      label: "Entrepôt",
      type: 'text',
      inList: true,
      inCsvExport: true,
      formatter: (context, value, item) => item.warehouse && item.warehouse.name ? item.warehouse.name : "-",
    },
    {
      // INC-003 : filtre entrepôt (select dans "Plus d'options")
      name: 'warehouse',
      label: "Entrepôt",
      type: 'select',
      extendedFilter: true,
    },
    {
      name: 'group_slug',
      label: "Service",
      type: 'select',
      inList: true,
      extendedFilter: true,
    },
    {
      name: 'stock',
      label: "Stock réel",
      type: 'text',
      inList: true,
      formatter: (context, value, item) => item.renting_preparation_products && item.renting_preparation_products.filter(rpp => rpp.product.stock < rpp.quantity).length > 0 ? 'out-of-stock' : 'on-stock'
    },
    {
      // Longue durée (SFD 2.8) : durées engagées portées par la préparation.
      name: 'long_term',
      label: "Engagement",
      inList: true,
      inCsvExport: true,
      formatter: (context, value, item) => {
        const months = (item.renting_preparation_products || [])
          .map((line) => line.long_term_months)
          .filter((m) => m);
        if (!months.length) {
          return null;
        }
        return [...new Set(months)].sort((a, b) => a - b).map((m) => m + " mois").join(", ");
      }
    },
    {
      // Filtre seul : le champ ci-dessus porte l'affichage, celui-ci le critère. Un champ ne
      // peut pas à la fois formater une valeur de ligne et servir de modèle de filtre.
      name: 'long_term_filter',
      label: "Engagement",
      type: 'select',
      extendedFilter: true,
    },
    {
      // Préparations des commandes d'échange (CM…-E) : badge sur la commande, filtre Type.
      name: 'type',
      label: "Type",
      type: 'select',
      extendedFilter: true,
    },
    
    // Form
    {
      name: 'products',
      label: "Produits",
      type: 'group_repeater',
      inForm: true,
      disableAdd: true,
      fields: [{
        name: 'product_id',
        label: "Produit",
        type: 'chosen',
        inForm: true,
      },
      {
        name: 'quantity',
        label: "Quantité",
        type: 'number',
        inForm: true,
      },
      ]
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/RentingPreparation/config.js